  function GiftonTop(){
    // Replace with your actual variant ID or cart key fragment
    const variantId = '43500520243391';

    // Find the cart item that contains this variant ID
    const itemToMove = document.querySelector(`.cart_page_item[data-variant-id="${variantId}"]`);

    if (itemToMove) {
      // Find the container holding all cart items
      const cartContainer = itemToMove.parentElement;

      // Move it to the top
      cartContainer.prepend(itemToMove);
    }
  }

   function isFreeGiftInCart(cartItems = [], variantId) {
    return cartItems.some(item =>
      String(item?.variant_id).trim() === String(variantId).trim()
    );
  }

  function handleFreeGiftLogic() {



    $.getJSON('/cart.js', function (cart) {
      const exchangeRate = Shopify.currency.rate;

      const cartTotalPriceFinal = cart.total_price / 100; // Convert from cents
      const secondGiftAmt = parseInt($("body").attr("second-amount"));
      let secondGiftAmount;
      if (window.shopCountry === "US" || window.shopCountry === "CA") {
         secondGiftAmount =  secondGiftAmt; // Example: US threshold
        } else {
          secondGiftAmount = exchangeRate * secondGiftAmt; // Default
        }
            
      // const secondGiftAmount = exchangeRate * secondGiftAmt;
      
       const freeGiftVariantId = 43500520243391;

      const freeGiftInCart = isFreeGiftInCart(cart.items, freeGiftVariantId);

      console.log("Cart total:", cartTotalPriceFinal, "Free gift in cart:", freeGiftInCart);

      if (cartTotalPriceFinal >= secondGiftAmount) {
        if (!freeGiftInCart) {
          // Add free gift
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              id: freeGiftVariantId,
              quantity: 1
            },
            dataType: "json",
            success: function (response) {
              console.log("Free gift added successfully", response);
              // updateCartUI();
            },
            error: function (xhr, status, error) {
              console.error("Error adding free gift", xhr, status, error);
            }
          });
        }
      } else {
        if (freeGiftInCart) {
          const freeGiftLineItem = cart.items.find(item => item.variant_id == freeGiftVariantId);
          if (freeGiftLineItem) {
            $.ajax({
              type: "POST",
              url: "/cart/change.js",
              data: JSON.stringify({
                id: freeGiftLineItem.key,
                quantity: 0
              }),
              contentType: 'application/json',
              dataType: "json",
              success: function (response) {
                console.log("Free gift removed successfully", response);
                window.location.reload();
              },
              error: function (xhr, status, error) {
                console.error("Error removing free gift", xhr, status, error);
              }
            });
          }
        }
      }
    });
  }

$(document).on("click", ".remove_current", function () {
  var $this = $(this);


  if ($(this).hasClass('remove_current_engrave')) {

    const lineItemKey = $this.data('line-item-key');
    // $(`.cart_page_item[data-key="${lineItemKey}"]`).remove();

    let variantIdToCheck = $(this).attr('data-property-var-id');
    $.getJSON('/cart.js', function (cart) {
    let lineItem = cart.items.find(item => item.variant_id == variantIdToCheck);     
    console.log('lineItem',lineItem);
    if (lineItem) {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: lineItem.id, // The unique key for the line item
          quantity: lineItem.quantity,
          properties: {
              'Color': lineItem.properties.Color,
              'Engraving Text': ''
          }
        },
        dataType: 'json',
        success: function (updatedCart) {
          console.log('Cart updated successfully:', updatedCart);
          $this.closest(".cart__item-sub").find(".js-qty__adjust--minus").trigger("click");

           GiftonTop();
        },
        error: function (error) {
          console.error('Error updating cart:', error);
        }
      });
    } else {
      console.log('No line item with the specified variant ID found in the cart.');
    }
  });
  } else if (!$(this).hasClass('remove_current_engrave')) { 
     var $this = $(this);
    const lineItemKey = $this.data('line-item-key');
    $(`.cart_page_item[data-key="${lineItemKey}"]`).remove();
    $.getJSON('/cart.js', function (cart) {
      console.log('Cart data:', cart);
        var variantIdCheck = $this.data("variant-id");
        console.log('variantIdCheck:', variantIdCheck);    
        let matchingItem = cart.items.find(item => {
            return item.properties && item.properties['Product variant id'] == variantIdCheck;
          });
        console.log('matchingItem:', matchingItem);    
        if (matchingItem) {
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
              id: matchingItem.key,
              quantity: matchingItem.quantity - 1,
            },
            dataType: 'json',
            success: function (updatedCart) {
              console.log('Cart updated successfully:', updatedCart);

                setTimeout(function () {
                $this.closest(".cart__item-sub").find(".js-qty__adjust--minus").trigger("click");
                   GiftonTop();
                }, 1000);
            },
            error: function (error) {
              console.error('Error updating cart:', error);
            }
          });
        } else {
          console.log('No matching item found for variantIdCheck:', variantIdCheck);
        }
    });
      $(this).closest(".cart__item-sub").find(".js-qty__adjust--minus").trigger("click");
        GiftonTop();
    }
     setTimeout(function () {
      $this.closest(".cart__item-sub").find(".js-qty__adjust--minus").trigger("click");
        GiftonTop();
      }, 1000);
    
  });

  document.addEventListener("DOMContentLoaded", function () {
    GiftonTop();
  });



$(document).on('click', '.remove-icon', function (e) {
  e.preventDefault();

  const $this = $(this);
  const lineItemKey = $this.data('line-item-key');
  const variantIdToCheck = $this.data('variant-id');
  const bodyElement = document.body;
  const freeGiftVariantId = bodyElement.dataset.freegift;

  $(`.cart_page_item[data-key="${lineItemKey}"]`).remove();


  $.getJSON('/cart.js', function (cart) {
    console.log('Cart data:', cart);
    let matchingItem = cart.items.find(item => {
      return item.properties && item.properties['Product variant id'] == variantIdToCheck;
    });
    console.log('matchingItem Remove Icon:', matchingItem);

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: JSON.stringify({
        id: lineItemKey,
        quantity: 0
      }),
      contentType: 'application/json',
      dataType: 'json',
      success: function (updatedCart) {
        console.log('Item removed successfully: Updated', updatedCart);
        // $this.closest(".remove-btn").find(".js-qty__adjust--minus").trigger("click");
        // $this.closest(".cart__item").remove();

        // After removing item, evaluate the free gift


        // document.dispatchEvent(new CustomEvent("cart:build"));

        // Update cart via theme's built-in AJAX function

        $(".orl-cart_count").text('( ' + updatedCart.item_count + ' )');

        if (updatedCart.item_count > 1) {
          $(".orl-cart_count-main").text('(' + updatedCart.item_count + ' items)');
        } else {
          $(".orl-cart_count-main").text('(' + updatedCart.item_count + ' item)');
        }

        // console.log("checing flkasjfsalkfsakjfsakf",updatedCart.item_count);


        document.dispatchEvent(
          new CustomEvent("cart:build")
        );

      
        

      },
      error: function (error) {
        console.error('Error removing item:', error);
      }
    });

  });



});


$(document).on('click', '.clear-cart', function () {
  clearCart();
});

function clearCart() {
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  })
    .then(response => {
      if (response.ok) {
        console.log('Cart cleared successfully.');
        // location.reload(); // Reload the page to reflect the changes
          window.location.href = '/discount/none?redirect=/cart';
      } else {
        console.error('Failed to clear the cart.');
      }
    })
    .catch(error => console.error('Error clearing the cart:', error));
}


$(document).on("click", ".custom-upsell-btn", function () {
  let variantId = $(this).parent().find(".custom-rec-variants").val();
  let arr = [];
  arr.push({ id: variantId, quantity: 1 });
  ATCtoCartDrawer(arr, $(this));
});
function ATCtoCartDrawer(productsArr, $this) {
  $this.addClass("active");
  let formData = {
    items: productsArr,
  };
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "xmlhttprequest",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .then((res) => {
      if (res.status) {
        toastr.error(res.description);
      } else {
        document.dispatchEvent(new CustomEvent("cart:build"));
        var cart = new theme.CartDrawer();
        cart.init();
        cart.open();
      }
    })
    .catch((error) => {
      console.error("Error test:", error);
    })
    .finally(() => {
      $this.removeClass("active");
    });
}

$(document).ready(function () {
  setTimeout(function () {
    $(".template-product .product-block.product-variants-block").css(
      "opacity",
      1
    );
  }, 1000);
  $(".template-product .product-variants-block .variant-wrapper").each(
    function () {
      var $gridContainer = $(this).find(".variant-input");
      var itemCount = $gridContainer.length;
      var columns;
      if (itemCount % 2 === 0) {
        columns = itemCount / 2;
      } else {
        columns = Math.ceil(itemCount / 2);
      }

      // console.log('columns = '+columns);
      $(this)
        .find("fieldset.variant-input-wrap")
        .css("grid-template-columns", "repeat(" + columns + ", 1fr)");
    }
  );

  const sentinel = document.querySelector('.sentinel');
  const buttonWrap = document.querySelector('.add-to-cart-details-wrap');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        buttonWrap.classList.remove('show-fixed');
      } else {
        buttonWrap.classList.add('show-fixed');
      }
    });
  }, {
    threshold: 1 // You can tweak this as needed
  });

  if (sentinel) {
    observer.observe(sentinel);
  }


  if (window.innerWidth <= 1024) {
  const paymentblock = document.querySelector('#stop-fix');
const fixedBlockCheckout = document.querySelector('.fixed-block-checkout');
const checkoutbtn = document.querySelector('.cart__checkout-wrapper');

let isPaymentBlockVisible = true;
let isFixedBlockCheckoutVisible = true;

const updateVisibility = () => {
  // Show fixed button only if BOTH elements are not visible
  if (!isPaymentBlockVisible && !isFixedBlockCheckoutVisible) {
    checkoutbtn.classList.add('show-fixed');
  } else {
    checkoutbtn.classList.remove('show-fixed');
  }
};

const observers = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.target === paymentblock) {
      isPaymentBlockVisible = entry.isIntersecting;
    } else if (entry.target === fixedBlockCheckout) {
      isFixedBlockCheckoutVisible = entry.isIntersecting;
    }

    updateVisibility();
  });
}, {
  threshold: 1 // Adjust threshold as needed
});

if (paymentblock) observers.observe(paymentblock);
if (fixedBlockCheckout) observers.observe(fixedBlockCheckout);
}

  
});



document.addEventListener("DOMContentLoaded", function () {

  prodImageSizing();

    
  document.documentElement.style.setProperty('--window-height', `${window.innerHeight}px`);

  const toggleSwitch = document.getElementById("toggle-switch");

  // Function to check if the container is present
  function checkForContainer(retries = 10) {
    const container = document.getElementById("avpoptions-container__v2");

    if (container) {
      console.log("Container found!");
      setupToggle(container);
    } else if (retries > 0) {
      // console.log("Container not found, retrying...");
      setTimeout(() => checkForContainer(retries - 1), 500); // Retry after 500ms
    } else {
      // console.error("Container not found after multiple attempts.");
    }
  }

  // Function to setup toggle functionality
  function setupToggle(container) {
    // Function to check the state of the toggle switch
    function checkSwitchState() {
      if (toggleSwitch.classList.contains("on")) {
        console.log("Switch is ON");
        container.classList.add("open-me-engrave"); // Add class
      } else {
        console.log("Switch is OFF");
        container.classList.remove("open-me-engrave"); // Remove class
      }
    }

    // Event listener for the toggle switch
    toggleSwitch.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default anchor behavior

      // Toggle the 'on' class
      toggleSwitch.classList.toggle("on");

      // Check the switch state
      checkSwitchState();
    });

    // Initial check to set the state on page load
    checkSwitchState();
  }

  // Start checking for the container
  checkForContainer();
});

$(document).on('click', function (e) {
  var $target = $(e.target);

  // Check if the click is outside CartDrawer, NavDrawer, custom-sticky-btn, and show-variants
  if (
    !$target.closest('#CartDrawer').length &&
    !$target.closest('#NavDrawer').length &&
    !$target.closest('.custom-sticky-btn').length &&
    !$target.closest('.show-variants').length
  ) {
    // Close CartDrawer
    $('#CartDrawer').removeClass('drawer--is-open');

    // Close NavDrawer
    $('#NavDrawer').removeClass('drawer--is-open');

    // Remove scroll lock and drawer-open class
    $('html').removeClass('js-drawer-open lock-scroll');

    $('.mega-menu').removeClass("active");
    $(".nav-item").removeClass("active");
    $(".sub-mega-menu").removeClass("active");
    $(".js-drawer-open-nav").removeClass("active");
    $("#SiteHeader").removeClass("active");
    $(".custom-ann-wrapper").slideDown();
    $(".mobile-nav .contact-info,.site-info-detail").css("display","block");
    $("#NavDrawer .custom-tp-image").css("display","block");
  }
});

$(document).ready(function () {
  $('.js-drawer-open-nav').on('click', function () {
    $(this).addClass('active');
    $("#SiteHeader").addClass("active");
    $(".custom-ann-wrapper").slideUp();

  });

// const priceElement = document.querySelector('.getpricetoround');
// if (priceElement) {
//   let priceText = priceElement.textContent;

//   // Remove currency symbols and whitespace
//   priceText = priceText.replace(/[^\d,.-]/g, '').trim();

//   // Convert comma to dot if it exists
//   if (priceText.includes(',')) {
//     priceText = priceText.replace(',', '.');
//   }

//   // Now safely parse the float
//   let price = parseFloat(priceText);

//   // Always round UP to the nearest 10
//   let roundedPrice = Math.ceil(price / 10) * 10;

//   // Replace the text content with formatted price (based on user's locale)
//   priceElement.textContent = roundedPrice.toLocaleString(undefined, {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2
//   });
// }

const priceElement = document.querySelector('.getpricetoround');
if (priceElement) {
  let originalText = priceElement.textContent.trim();

  // Extract the currency symbol or abbreviation (handle €  or spaces)
  const currencyMatch = originalText.match(/^(Rs\.?|€|£|\$|₹)/);
  const currencySymbol = currencyMatch ? currencyMatch[0].replace('.', '').trim() : '';

  // Remove the symbol and keep only digits + comma/dot
  let priceText = originalText.replace(/[^\d.,]/g, '');

  // Detect if it's EU-style format (comma is decimal)
  const isEuropeanFormat = priceText.includes(',') && (
    !priceText.includes('.') || priceText.indexOf(',') > priceText.indexOf('.')
  );

  if (isEuropeanFormat) {
    priceText = priceText.replace(/\./g, '').replace(',', '.'); // "9.330,87" → "9330.87"
  } else {
    priceText = priceText.replace(/,/g, ''); // "9,330.87" → "9330.87"
  }

  const price = parseFloat(priceText);
  const roundedPrice = Math.ceil(price / 10) * 10;

  // Map symbol to locale
  const currencyLocaleMap = {
    '€': 'fr-FR', // French or 'de-DE' for German
    '£': 'en-GB',
    '$': 'en-US',
    'Rs': 'en-PK',
    '₹': 'en-IN',
  };

  const selectedLocale = currencyLocaleMap[currencySymbol] || 'en-US';

  const formattedPrice = roundedPrice.toLocaleString(selectedLocale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  priceElement.textContent = `${currencySymbol} ${formattedPrice}`;
}


  // This is working but dont for the round of 10
  // const priceElement = document.querySelector('.getpricetoround');
  // let priceText = priceElement.textContent.replace(/,/g, '');
  // let price = parseFloat(priceText);

  // // Always round UP to the nearest 10
  // let roundedPrice = Math.ceil(price / 10) * 10;

  // // Format with commas and two decimal places
  // priceElement.textContent = roundedPrice.toLocaleString(undefined, {
  //   minimumFractionDigits: 2,
  //   maximumFractionDigits: 2
  // });



});

$(".js-drawer-close").click(function () {

  $('.mega-menu').removeClass("active");
  $('.mega-menu .child').removeClass("active");
  $(".nav-item").removeClass("active");
  $(".sub-mega-menu").removeClass("active");
  $(".js-drawer-open-nav").removeClass("active");
  $(".custom-ann-wrapper").slideDown();
  $("#SiteHeader").removeClass("active");
  $(".mobile-nav .contact-info,.site-info-detail").css("display","block");
  $("#NavDrawer .custom-tp-image").css("display","block");
});


$(".mobile-nav .nav-item").click(function () {
  if ($(this).hasClass("active")) {
    $(this).find($('.mega-menu')).removeClass("active");
    $(this).removeClass("active");
     $(this).find($('.mega-menu .icon-back')).removeClass("active");
     $(".mobile-nav .contact-info,.site-info-detail").css("display","block");
     $("#NavDrawer .custom-tp-image").css("display","block");
  } else {

    $('.mega-menu').removeClass("active");
    $(".nav-item").removeClass("active");
    $(this).find($('.mega-menu')).addClass("active");
    $(this).find($('.mega-menu .icon-back')).addClass("active");
    $(this).addClass("active");
    $(".mobile-nav .contact-info,.site-info-detail").css("display","none");
    $("#NavDrawer .custom-tp-image").css("display","none");
  }
});



$(".mobile-nav .nav-item").hover(
  function () {
    // On hover in
    $(this).addClass("active-hover");
    $(".mobile-nav .nav-item").not(this).addClass("disable");
  },
  function () {
    // On hover out
    $(this).removeClass("active-hover");
    $(".mobile-nav .nav-item").removeClass("disable");
  }
);

$(".mobile-nav .nav-item .mega-menu .child").hover(
  function () {
    // On hover in
    $(this).addClass("active-hover");
    $(".mobile-nav .nav-item .mega-menu .child").not(this).addClass("disable");
  },
  function () {
    // On hover out
    $(this).removeClass("active-hover");
    $(".mobile-nav .nav-item .mega-menu .child").removeClass("disable");
  }
);

// Toggle sub-dropdowns
$(".mega-menu .child").click(function (e) {
  e.stopPropagation(); // Prevent event bubbling
  if ($(this).hasClass("active")) {
    $(this).find(".sub-mega-menu").removeClass("active");
    $(this).removeClass("active");
    $(this).find($('.sub-mega-menu .icon-back')).removeClass("active");
    $('.mega-menu .icon-back').addClass("active");
    // $(".mobile-nav .contact-info,.site-info-detail").css("display","block");
  } else {
    $(".sub-mega-menu").removeClass("active");
    $(".mega-menu .child").removeClass("active");
    $(".mega-menu .icon-back").removeClass("active");
    $(this).find(".sub-mega-menu").addClass("active");
    $(this).addClass("active");
     $(this).find($('.sub-mega-menu .icon-back')).addClass("active");
     
     $("#NavDrawer .custom-tp-image").css("display","none");
  }
});

$(".sub-mega-menu .sub-child").click(function (e) {
  e.stopPropagation(); // Prevent event bubbling
  if ($(this).hasClass("active")) {
    // $(this).find(".sub-mega-menu").removeClass("active");
    // $(this).removeClass("active");
  } else {

  }
});


$(document).ready(function () {
  function handleDesktopClick() {
    if (window.innerWidth >= 768) {
      $(document).on("click", ".custom-collection-atc-btn", function (e) {
        e.preventDefault();
        $(".custom-collection-atc-btn-wrapper").show();
        $(this).closest(".custom-collection-atc-btn-wrapper").hide();
        $(".collection-product-variant-block").removeClass("show_variants");
        $(this)
          .closest(".custom-main-collection-grid")
          .find(".collection-product-variant-block")
          .addClass("show_variants");
      });
    } else if (window.innerWidth <= 767) {
      $(document).on("click", ".custom-collection-atc-btn", function (e) {
        e.preventDefault();
        $(this)
          .closest(".custom-main-collection-grid")
          .find(".collection-product-variant-block")
          .addClass("show_variants");
        $(this)
          .closest(".custom-main-collection-grid")
          .find(".custom-coll-variant-for-mobile")
          .show();
        $(".quickview-overlay").addClass("show_overlay");
        $("html").addClass("locked-scroll");
      });
      $(document).on("click", ".quickview-overlay", function (e) {
        e.preventDefault();
        $("html").removeClass("locked-scroll");
        $(".quickview-overlay").removeClass("show_overlay");
        $(".custom-coll-variant-for-mobile").hide();
        console.log("classRemoved");
      });
    }
  }
  
  handleDesktopClick();
  $(window).on("resize", function () {
    handleDesktopClick();
    // if (window.innerWidth >= 768) {}
    // prodImageSizing();
  });


  // COLLECTION PAGE PRODUCT VARIANT CLICK
  $(document).on("click", ".collection-product-variant", function (e) {
    e.preventDefault();
    $(".collection-product-variant").removeClass("selected");
    $(this).addClass("selected");
  });

  // COLLECTION PAGE PRODUCT ATC
  $(document).on(
    "click",
    ".custom-collection-atc-btn.custom-coll-product-atc",
    function (e) {
      e.preventDefault();
      if (window.innerWidth >= 768) {
        $(this)
          .closest(".custom-main-collection-grid")
          .find(".custom-collection-atc-btn-wrapper")
          .hide();
      }
      var selected_id = $(this)
        .closest(".collection-product-variant-block")
        .find(".collection-product-variant.selected")
        .attr("data-variant-id");


      $.ajax({
        url: "/cart/add.js",
        type: "post",
        dataType: 'json',
        data: { quantity: 1, id: selected_id },
        success: function (data) {

          sessionStorage.setItem('lastAddedVariantId', data.variant_id); // Save the latest added variant ID

          $(".quickview-overlay").removeClass("show_overlay");
          $(".custom-coll-variant-for-mobile").hide();
          $("html").removeClass("locked-scroll");

          var cart = new theme.CartDrawer();
          // cart.init();
          cart.open();

          // setTimeout(function () {
          //   $('#CartDrawerForm .cart__items').html(newItem);
          // }, 1000);

        },
        error: function (xhr, status, error) {
        let response = JSON.parse(xhr.responseText);

          // Show the error message in a custom way (e.g., alert, toast, inline div)
          alert(response.message); // Replace with your own UI component for better UX
          // Example: $('.custom-error-message').text(response.message).show();
        },
        
      });
    }
  );


  $(".custom-collection-atc-btn-single-vairant").on("click", function (e) {

    console.log("THIS IS THE SINGLE COLLECTION CONSOLE")
    e.preventDefault();
    var selected_var_id = $(this).attr("data-product-id");
    $.ajax({
      url: "/cart/add.js",
      type: "post",
      dataType: 'json',
      data: { quantity: 1, id: selected_var_id },
      success: function (data) {

        sessionStorage.setItem('lastAddedVariantId', data.variant_id); // Save the latest added variant ID

        var cart = new theme.CartDrawer();
        // cart.init();
        cart.open();

      },
    });
  });


});


// custom js for trigger loox review accordion
$(document).ready(function () {

  // If the custom sidebar toggle has the show-msg-box class, show it; otherwise, hide and clear the note
  if ($(".custom-sidebar-toggle.art-bg").hasClass("show-msg-box")) {
    $(".custom-sidebar-toggle.art-bg").css("display", "flex");
    // document.querySelector(".custom-sidebar-toggle.art-bg").style.display = "flex";
  } else {
    $(".custom-sidebar-toggle.art-bg").css("display", "none");
  }

});


$(document).ready(function () {
  $('.pro-loox-review').click(function (e) {
    e.preventDefault(); // Prevent default anchor behavior
    $('html, body').animate({
      scrollTop: $('#looxReviews').offset().top - 100
    }, 800); // 800ms for smooth scroll
  });
});



(function ($) {
  $(function () {

    if ($('.logos-block-wrapper').attr('data-marquee') === 'true') {
      $('.logos-block-wrapper').slick({
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 14000,
        cssEase: 'linear',
                rows: 0,
        responsive: [
          {
            breakpoint: 1320,
            settings: {
              slidesToShow: 3,
              speed: 14000,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 1080,
            settings: {
              slidesToShow: 3,
              speed: 14000,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 680,
            settings: {
              slidesToShow: 2,
              speed: 14000,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              speed: 14000,
              slidesToScroll: 1
            }
          }]
      });
    } else {
      $('.logos-block-wrapper').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 1000,
        arrows: false,
        rows: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }
        ]
      });
    }

    $('.reels-slider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      infinite: false,
      autoplaySpeed: 3000,
      arrows: false,
      rows: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            // arrows: true,
            // prevArrow: $('.custom-prev'),
            // nextArrow: $('.custom-next'),
            infinite: true,
            dots: true,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            // arrows: true,
            // prevArrow: $('.custom-prev'),
            // nextArrow: $('.custom-next'),
            infinite: true,
            dots: true,
          }
        }
      ]
    });
    $('.custom-iwl-flex-wrapper').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      infinite: false,
      autoplaySpeed: 3000,
      arrows: false,
      rows: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
             autoplay: false,
              centerMode: true,
              centerPadding: '20px', // You can adjust for design

            // arrows: true,
            // prevArrow: $('.custom-prev'),
            // nextArrow: $('.custom-next'),
            infinite: false,
            dots: true,
            
          }
        }
      ]
    });
   

  $('.category-block-wrapper').slick({
    slidesToShow: 4.5,
    slidesToScroll: 1,
    autoplay: true,
    infinite: false,
    autoplaySpeed: 5000,
    arrows: true,
    prevArrow: $('.arrow-btn .slick-prev'),
    nextArrow: $('.arrow-btn .slick-next'),
    speed: 300,              // Faster response
    touchThreshold: 10,      // Make it more sensitive
    swipeToSlide: true,      // Allow natural drag to slide (important!)
    draggable: true,
    touchMove: true,
    cssEase: 'ease-out',
     rows: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 1,
          swipeToSlide: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          swipeToSlide: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,

          swipeToSlide: true
        }
      }
    ]
  });

    $('.cus-meta-pro-upsell').slick({
      slidesToShow:3,
      slidesToScroll: 1,
      autoplay: false,
      infinite: false,
      autoplaySpeed: 3000,
      arrows: false,
      rows: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            // arrows: true,
            // prevArrow: $('.custom-prev'),
            // nextArrow: $('.custom-next'),

          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            // arrows: true,
            // prevArrow: $('.custom-prev'),
            // nextArrow: $('.custom-next'),

          }
        }
      ]
    });
    // $('.necklace-builder-slider').slick({
    //   slidesToShow:1,
    //   slidesToScroll: 1,
    //   autoplay: false,
    //   infinite: false,
    //   autoplaySpeed: 3000,
    //   arrows: false,
    //   responsive: [
    //     {
    //       breakpoint: 1024,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //       }
    //     },
    //     {
    //       breakpoint: 767,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         // arrows: true,
    //         // prevArrow: $('.custom-prev'),
    //         // nextArrow: $('.custom-next'),

    //       }
    //     },
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         slidesToShow: 2,
    //         slidesToScroll: 2,
    //         // arrows: true,
    //         // prevArrow: $('.custom-prev'),
    //         // nextArrow: $('.custom-next'),

    //       }
    //     }
    //   ]
    // });

  



  });
})(jQuery);



document.addEventListener('DOMContentLoaded', function () {

  handleFreeGiftLogic();

  const insuranceCheckbox = document.querySelector('.insr_check'); // Checkbox for insurance
  const insuranceCheckboxCart = document.querySelector('.insr_check_cart'); // Checkbox for insurance
  const giftCheckbox = document.querySelector('.gift_check'); // Checkbox for insurance
  const giftCheckboxCart = document.querySelector('.gift_check_cart'); // Checkbox for insurance
  const giftCheckboxlargeCart = document.querySelector('.gift_check_large_cart'); // Checkbox for Large Gift
  const checkboxforcleaningmate = document.querySelector('.cleaning_mate_cart'); // Checkbox for insurance
  const GiftNote = document.querySelector('.gift_note_cart'); // Checkbox for insurance
  const cartTotal = document.querySelector('.cartTotal'); // Cart total element
  const cartsubTotal = document.querySelector('.cartsubtotal'); // Cart total element
  const cartitemTotal = document.querySelector('.cartitemtotal'); // Cart total element

  const cartTotalupdated = document.getElementById('cartTotalUpdated'); // Cart total element
  const cartTotalPrice = document.querySelector('[data-total_price]'); // Cart total data attribute element

  const insuranceVariantId = 43684089692351;
  const giftVariantId = 54900395868535;
  const giftLargeVariantId = 55073221968247;
  const cleaningmate = 55274346807671;
  const giftNoteId = 55073318568311;


  const addonVariantIds = [
    43684089692351, // insurance
    54900395868535, // gift
    43696483074239, // variant id
    55073221968247, // gift large
    55073318568311,  // gift note
    55274346807671
  ];

  function removeOnlyAddonsCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const allItemsAreAddons = cart.items.every(item => addonVariantIds.includes(item.variant_id));

        if (allItemsAreAddons && cart.items.length > 0) {
          // Cart only has addon items → clear it
          fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          }).then(() => {
            console.log('Cart had only addons. Cleared.');
               setTimeout(() => {
                  location.reload(); // optional: to update the cart UI
              }, 200);
          });
        } else {
          console.log('Cart has non-addon items, no need to clear.');
        }
      })
      .catch(error => console.error('Error checking cart:', error));
  }


  // Function to update the cart total
  function updateTotal(newTotal) {


    fetch('/cart.json', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(response => response.json())  // Parse the JSON response
      .then(data => {

        var firstAmount = $("body").attr("first-amount");
        var firstGiftAmt = parseInt(firstAmount);

        var secondGift = $("body").attr("second-amount");
        var secondGiftAmt = parseInt(secondGift);

        const exchangeRate = Shopify.currency.rate;
        var firstGiftAmount = exchangeRate * firstGiftAmt;
        var secondGiftAmount = exchangeRate * secondGiftAmt;

        let remainingFirstGift = firstGiftAmount;
        let remainingSecondGift = secondGiftAmount;
        // var currencySymbol = "£";
        var moneySymbol = document.body.getAttribute('data-money');
        var currencySymbol = moneySymbol.replace(/\s*\{\{.*\}\}/, '').trim();

        var cartTotalPriceFinal = data.total_price / 100;

        // Check if the cart total price is less than remainingFirstGift
        if (cartTotalPriceFinal < remainingFirstGift) {
          remainingFirstGift -= cartTotalPriceFinal; // Subtract cart total price from remainingFirstGift
          // Update the 'money_spent1' div with the remainingFirstGift
          $(".money_spent").text(currencySymbol + "" + remainingFirstGift.toFixed(2)); // Show the remaining amount in the div
        } else {

          remainingFirstGift -= cartTotalPriceFinal;
          if (remainingFirstGift < cartTotalPriceFinal) {

            remainingSecondGift -= cartTotalPriceFinal;
            $(".money_spent").text(currencySymbol + "" + remainingSecondGift.toFixed(2));
          }
        }


        // Step 2: Assume formattedTotal is given in the Shopify format, e.g. 'Rs.14,300.00'
        let formattedTotal = Shopify.formatMoney(newTotal * 100); // Shopify format, assuming `newTotal` is a number
        // Remove the currency symbol, get only the numeric value
        formattedTotalNormal = formattedTotal.replace(/^[\p{Sc}\s]+/gu, currencySymbol);
        cartTotal.innerText = formattedTotalNormal;
        cartsubTotal.innerText = formattedTotalNormal;
        cartitemTotal.innerText = formattedTotalNormal;

      })
      .catch(error => {
        // handle any errors
        console.error('Error fetching cart data:', error);
      });


    // Update the data-total_price attribute
    if (cartTotalPrice) {
      cartTotalPrice.setAttribute('data-total_price', newTotal);
    }
  }

  // Function to add or ensure the insurance product is in the cart with quantity 1


  function clearTextArea() {
    var textArea = document.getElementById("CartNote");
    textArea.value = '';  // Clears the content of the textarea
  }

  // Add or update the cart note
  function updateCartNote(note) {
    var data = {
      note: note
    };

    // Send a request to update the cart
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(data => {
        console.log('Cart updated with note:', data);
      })
      .catch((error) => {
        console.error('Error updating cart:', error);
      });
  }


function updateGiftNoteProperties(giftNoteId, properties) {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const giftNoteItem = cart.items.find(item => item.variant_id === giftNoteId);
      if (giftNoteItem) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: giftNoteItem.key, // This is the line item key
            quantity: giftNoteItem.quantity,
            properties: properties
          })
        }).then(() => {
          window.location.reload();
        });
      }
    });
}


  function addOrEnsureProductQuantity(insuranceItemId,reload) {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(response => response.json())
      .then(cart => {
        const insuranceItem = cart.items.find(item => item.variant_id === insuranceItemId);
        console.log("Checking the variant id for insureace", insuranceItemId);

        // Function to update the cart UI using your AJAX snippet

        if (insuranceItem) {
          if (insuranceItem.quantity !== 1) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify({
                id: insuranceItem.key,
                quantity: 1,
              }),
            })
              .then(() => fetch('/cart.js'))
              .then(response => response.json())
              .then(cart => {
                updateTotal(cart.original_total_price / 100);
                $(".orl-cart_count").text('( ' + cart.item_count + ' )');
                // $(".orl-cart_count-main").text(cart.item_count);
                 if (cart.item_count > 1) {
                  $(".orl-cart_count-main").text('(' + cart.item_count + ' items)');
                } else {
                  $(".orl-cart_count-main").text('(' + cart.item_count + ' item)');
                }
                $(".cart-link .ddcc .custom-cart--count").text(cart.item_count);
                // updateCartUI();
                
                handleFreeGiftLogic();
                   setTimeout(function(){
                      window.location.reload();
                   },1000)
              
               
              });
          }
        } else {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              id: insuranceItemId,
              quantity: 1,
            }),
          })
            .then(() => fetch('/cart.js'))
            .then(response => response.json())
            .then(cart => {
              updateTotal(cart.original_total_price / 100);
              $(".orl-cart_count").text('( ' + cart.item_count + ' )');
              // $(".orl-cart_count-main").text(cart.item_count);
               if (cart.item_count > 1) {
                $(".orl-cart_count-main").text('(' + cart.item_count + ' items)');
                } else {
                  $(".orl-cart_count-main").text('(' + cart.item_count + ' item)');
                }
              $(".cart-link .ddcc .custom-cart--count").text(cart.item_count);
              // updateCartUI();
                // window.location.reload();
                   handleFreeGiftLogic();
                   setTimeout(function(){
                     if(reload != true){
                      window.location.reload();
                    }
                   },1000)
            });
        }
      })
      .catch(error => console.error('Error checking cart:', error));
  }

  // Function to remove the insurance product from the cart
  function removeProductFromCart(insuranceItemId) {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(response => response.json())
      .then(cart => {
        const insuranceItem = cart.items.find(item => item.variant_id === insuranceItemId);

        if (insuranceItem) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              id: insuranceItem.key,
              quantity: 0,
            }),
          })
            .then(() => fetch('/cart.js'))
            .then(response => response.json())
            .then(cart => {
              updateTotal(cart.original_total_price / 100);
              $(".orl-cart_count").text('( ' + cart.item_count + ' )');
              // $(".orl-cart_count-main").text(cart.item_count);
               if (cart.item_count > 1) {
              $(".orl-cart_count-main").text('(' + cart.item_count + ' items)');
              } else {
                $(".orl-cart_count-main").text('(' + cart.item_count + ' item)');
              }
              $(".cart-link .ddcc .custom-cart--count").text(cart.item_count);
              // updateCartUI();
              handleFreeGiftLogic();
                   setTimeout(function(){
                   
                      window.location.reload();
                   
                   },1000)
            });
        }
      })
      .catch(error => console.error('Error checking cart:', error));
  }


  insuranceCheckboxCart?.addEventListener('change', function () {
    const parent = insuranceCheckboxCart.parentElement;
    if (insuranceCheckboxCart.checked) {
      parent.classList.add('insurance-checked');
      addOrEnsureProductQuantity(insuranceVariantId);
      removeOnlyAddonsCart();
    } else {
      parent.classList.remove('insurance-checked');
      removeProductFromCart(insuranceVariantId);
      removeOnlyAddonsCart();
    }
  });

  giftCheckboxCart?.addEventListener('change', function () {


    const parent = giftCheckboxCart.parentElement;
    if (giftCheckboxCart.checked) {
      parent.classList.add('gift-checked');
      addOrEnsureProductQuantity(giftVariantId);
      removeOnlyAddonsCart();
    } else {
      parent.classList.remove('gift-checked');
      removeProductFromCart(giftVariantId);
      removeOnlyAddonsCart();
    }
  });

  giftCheckboxlargeCart?.addEventListener('change', function () {


    const parent = giftCheckboxlargeCart.parentElement;
    if (giftCheckboxlargeCart.checked) {
      parent.classList.add('gift-large-checked');
      addOrEnsureProductQuantity(giftLargeVariantId);
      removeOnlyAddonsCart();
    } else {
      parent.classList.remove('gift-large-checked');
      removeProductFromCart(giftLargeVariantId);
      removeOnlyAddonsCart();
    }
  });

  checkboxforcleaningmate?.addEventListener('change', function () {

    const parent = checkboxforcleaningmate.parentElement;
    if (checkboxforcleaningmate.checked) {
      parent.classList.add('cleaning-mate-checked');
      addOrEnsureProductQuantity(cleaningmate);
      removeOnlyAddonsCart();
    } else {
      parent.classList.remove('cleaning-mate-checked');
      removeProductFromCart(cleaningmate);
      removeOnlyAddonsCart();
    }
  });

  GiftNote?.addEventListener('change', function () {

    const stopreloading = true;
    const parent = GiftNote.parentElement;
    const customSidebarToggle = document.querySelector('.custom-sidebar-toggle');

    $("#CartNote").val("");
    var note = "";
    clearTextArea();
    setTimeout(() => {
      updateCartNote(note);
    }, 200);
    if (GiftNote.checked) {
      parent.classList.add('gift-note-checked');
      addOrEnsureProductQuantity(giftNoteId,stopreloading);
      // Show the custom sidebar toggle when the gift note is checked
      removeOnlyAddonsCart();
      customSidebarToggle.classList.add('show-msg-box');

      setTimeout(function () {
        $(".custom-sidebar-toggle.show-msg-box").trigger("click");
      }, 200);

    } else {
      parent.classList.remove('gift-note-checked');
      clearTextArea();
      removeProductFromCart(giftNoteId,stopreloading);
      removeOnlyAddonsCart();
      customSidebarToggle.classList.remove('show-msg-box');
      var note = "";
      setTimeout(() => {
        updateCartNote(note);
      }, 200);

      $("#noteVal").text("Add a personal note");

      $(".ol-gift-footer button").click();

    }

  });

  document.querySelector("#cart-note-form .custom-sidebar-title span")?.addEventListener("click", function () {
    var giftNote = document.querySelector(".gift_note_cart");
    if ($("#CartNote").val() === "") {
      giftNote.checked = false;
      removeProductFromCart(giftNoteId);
      document.querySelector(".custom-sidebar-toggle.art-bg").style.display = "none";
    } else {
      document.querySelector(".custom-sidebar-toggle.art-bg").style.display = "flex";
    }



  })

  document.getElementById("cart-note-form")?.addEventListener("submit", function (e) {
    e.preventDefault();


    var note = document.getElementById("CartNote").value.trim();
    var giftNote = document.querySelector(".gift_note_cart");

    // Update the cart note
    updateCartNote(note);

    if (note === "") {
      giftNote.checked = false;
      removeProductFromCart(giftNoteId);
      removeOnlyAddonsCart();
      document.querySelector(".custom-sidebar-toggle.art-bg").style.display = "none";
    } else {
      giftNote.checked = true;
      addOrEnsureProductQuantity(giftNoteId);
      updateGiftNoteProperties(giftNoteId, { "Gift Note": note });

      removeOnlyAddonsCart();
      document.querySelector(".custom-sidebar-toggle.art-bg").style.display = "flex";



    }

      // setTimeout(() => {
      //    window.location.reload();  
      // }, 1500);

  });


  giftCheckbox?.addEventListener('change', function () {


    const parent = giftCheckbox.parentElement;
    if (giftCheckbox.checked) {
      parent.classList.add('gift-checked');
      addOrEnsureProductQuantity(giftVariantId);
      removeOnlyAddonsCart();
    } else {
      parent.classList.remove('gift-checked');
      removeProductFromCart(giftVariantId);
      removeOnlyAddonsCart();
    }
  });


  document.querySelector(".ov-gift-message__remove")?.addEventListener("click", function () {
    clearTextArea();
  });

  // Prevent the Enter key press when 6 lines are typed
  document.getElementById('CartNote')?.addEventListener('keydown', function (event) {
    var textarea = document.getElementById('CartNote');
    var lines = textarea.value.split('\n').length;
    var maxLines = 6;

    // If Enter is pressed and 6 lines have been reached, prevent default behavior
    if (lines >= maxLines && event.key === 'Enter') {
      event.preventDefault();
    }
  });



});

document.addEventListener("DOMContentLoaded", function () {

  elementexist = document.querySelector(".product_container__image .splide");
  if (!elementexist) {
    return; // Exit if the element does not exist
  } 

  const splide = new Splide('.product_container__image .splide', {
    arrows: false,
    autoWidth: true,
    pagination: false,
    type: 'loop',
    drag: 'free',

    autoScroll: {
      speed: 0.5,
      // pauseOnHover: false,
      pauseOnFocus: false,
    },
  });

splide.mount(window.splide.Extensions);  // Includes autoScroll etc.

  Fancybox.bind(".product_container__image .splide__slide:not(.splide__slide--clone) .zoom-image[data-fancybox='gallery']", {
    Thumbs: false, // Hide thumbnails if not needed
    Toolbar: true,
    zoom: true,
    on: {
      close: () => {
        // Restart autoScroll
        splide.Components.AutoScroll.play();
      }
    }
  });


  // const items = document.querySelectorAll("#ShoppingDrawerForm .cart_drawer_item");

  // items.forEach((item, index) => {
  //   item.style.display = index === 0 ? "flex" : "none";
  // });

  //   const priceround = document.querySelector(".getpricetoround");
  // if (priceround) {
  //     let price = parseFloat(priceround.textContent);
  //     if (!isNaN(price)) {
  //         let roundedPrice = Math.round(price); // Round to nearest whole number
  //         let formattedPrice = roundedPrice.toFixed(2); // Format as "36.00"
  //         priceround.textContent = formattedPrice; // Optional: Update the div with rounded price
  //         console.log(formattedPrice); // Output: "36.00", "39.00", etc.
  //     } else {
  //         console.log("Invalid number in div");
  //     }
  // }

  var giftNote = document.querySelector(".gift_note_cart");
  if ($("#CartNote").val() === "") {
    giftNote.checked = false;
    removeProductFromCart(giftNoteId);
    document.querySelector(".custom-sidebar-toggle.art-bg").style.display = "none";
  } else {
    document.querySelector(".custom-sidebar-toggle.art-bg").style.display = "flex";
  }

    // var headHeight = document.querySelector("#StickyHeaderWrap").clientHeight,
    //     positionTop = document.querySelector(".wrapper-sticker");
    //     positionTop.style.top = headHeight;
});


function prodImageSizing() {

  var exist = document.querySelector(".custom-product-info-container .product-single__meta");
  if (!exist) {
    return; // Exit if the element does not exist
  }
  var headHeight = document.querySelector("#StickyHeaderWrap").clientHeight,
    contentHeight = document.querySelector(".custom-product-info-container .product-single__meta").clientHeight,
    imgArray = document.querySelectorAll(".product_container__image img, .product_container__image video");
  

const isMobile = window.innerWidth <= 991;
const isSmallMobile = window.innerWidth <= 576;

const totalOffset = 
window.innerHeight < 750
  ? headHeight + 200
  : (isSmallMobile
      ? headHeight + 450
      : (isMobile
          ? headHeight + 250
          : headHeight + contentHeight));

  const mobileHeight = 400;

// const totalOffset = 1;
if (isMobile) {
  imgArray.forEach(img => {
    img.style.height = "calc(" + mobileHeight + "px)";
    img.style.width = "calc(" + mobileHeight + "px)";
  });
}else{
  imgArray.forEach(img => {
    img.style.height = "calc(" + window.innerHeight + "px - " + (totalOffset) + "px)";
    img.style.width = "calc(" + window.innerHeight + "px - " + (totalOffset) + "px)";
  });
}


}



// theme.js Javascript Code for Optimizing the Theme 

// code from line 521 of theme.js


let times = [2000, 4000, 6000, 8000, 10000];

times.forEach(function (time) {
  setTimeout(function () {
    console.log('trigger-js-drawer');
    $(".cart__item-title .cart__item-name, .empty-cart-text").each(function () {
      let originalText = $(this).html();
      let newText = originalText.replace(/(\d+)/g, '<span class="special-class">$1</span>');
      $(this).html(newText);
    });
  }, time);

});


document.addEventListener('DOMContentLoaded', function () {
  // Show Variation Popup

  var headHeight = document.querySelector("#StickyHeaderWrap").clientHeight;
  var positionTop = document.querySelector(".wrapper-sticker");
  var checkoutpositionTop = document.querySelector(".cart__checkout-wrapper");
  if (positionTop) {
    positionTop.style.position = "sticky";
    positionTop.style.top = headHeight + "px";
    // positionTop.style.marginBottom = "50px";
  }
  if (checkoutpositionTop) {
    // positionTop.style.position = "sticky";
    checkoutpositionTop.style.top = headHeight + "px";
  }

  function showVariationPopup() {
    document.getElementById('variation-popup').style.display = 'block';
  }

  // Close Variation Popup
  function closeVariationPopup() {
    document.getElementById('variation-popup').style.display = 'none';
  }

  // Handle Add to Cart button click
  document.querySelectorAll('.custom-main-add-to-cart').forEach(button => {
    button.addEventListener('click', function () {
      showVariationPopup();
    });
  });

  // Handle Quick Checkout button click
  document.getElementById('quick-checkout-btn')?.addEventListener('click', function () {
    const productId = this.getAttribute('data-product-id');
    // Redirect to checkout with the product
    window.location.href = `/checkout?add=${productId}&quantity=1`;
  });

  // Handle variant popup form submission
  document.getElementById('variant-form')?.addEventListener('submit', function (event) {
    event.preventDefault();
    const selectedVariant = document.querySelector('input[name="variant"]:checked').value;
    const engravingText = document.querySelector(`#engraving-text-${productId}`).value;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: selectedVariant,
          quantity: 1,
          properties: { 'Engraving Text': engravingText }
        }]
      })
    }).then(response => response.json())
      .then(data => {
        alert('Product added to cart!');
        closeVariationPopup();
      }).catch(error => {
        console.error('Error:', error);
      });
  });

  // Close the popup when clicking the close button
  document.querySelector('.variation-popup-close')?.addEventListener('click', closeVariationPopup);

  // Close the popup when clicking outside of the popup content
  window.addEventListener('click', function (event) {
    if (event.target.classList.contains('variation-popup')) {
      closeVariationPopup();
    }
  });
});



$(document).ready(function () {

  $('.flex-me').click(function (event) {
    event.preventDefault();
    if ($('.toggle-switch').hasClass('on')) {
      $('.toggle-switch').removeClass('on');
      $('.avpoptions-container__v2').removeClass('open-me-engrave');
    } else {
      $('.toggle-switch').addClass('on');
      $('.avpoptions-container__v2').addClass('open-me-engrave');
    }
  });

    $('.carousel-rtl').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrow: true,
    dots: true,
    autoplay:true,
    rtl: true,
      rows: 0,
  });

});

$(window).on('load', function () {
  let value = $('.apo-title-addcharge').text().trim();
  value = value.replace(/[()+]/g, '').trim();
  $('.cus-engraving-price').text(value);
  $('.avpoptions-container__v2 label.avp-option-title .apo-title').text('Add your engraving text below');
  let engravePlaceholder = 'e.g. FOR JANE';
  $('.custom-main-product-grid .apo-text-field .avp-productdescfont').attr('placeholder', engravePlaceholder);
});


let checkBanner = setInterval(() => {
  let bannerBody = document.querySelector('.shopify-pc__banner__body');
  
  if (bannerBody) {
        document.body.insertAdjacentHTML('beforeend', '<div id="overlay" class="active"></div>');
         document.documentElement.classList.add("locked-scroll");
    bannerBody.innerHTML += `
                <h3>YOUR COOKIE PREFERENCES</h3>
                <h4>WELCOME TO outrageldn.com</h4>
                <p>
                    Outrage London uses cookies, including third-party cookies, for functional reasons, for statistical analysis, 
                    to personalise your experience, offer you content that targets your particular interests and analyse the performance of our advertising campaigns.<br><br>
                    You can either accept these cookies by clicking "Accept and Continue", or click "Set cookie preferences" to set your preferences.
                </p>
            `;
    clearInterval(checkBanner); // Stop checking once the element is found
  }

}, 100); // Check every 100ms

let interval = setInterval(function () {
  let target = $('.shopify-pc__banner__btns');
  if (target.length) {
    target.after(`
                <div class="shopify-pc__banner__footer">
                    <p>You can change your preferences at any time by going to the "Cookies" module or to the "Privacy Policy" sub-section of the "LEGAL & PRIVACY" section. They are accessible through links at the bottom of any outrageldn.com website page.</p>
                    <p>For more information on our cookie policy, please <a id="shopify-pc__banner__body-policy-link" href="https://outrageldn.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer">click here.</a></p>
                    <p class="footer-banner-logo"><a href="/">
                      <img src="//outrageldn.com/cdn/shop/files/Outrage_LONDON_800_x_200_px_950_x_250_px_1200_x_300_px_1200_x_300_px_4.png?v=1708272716" alt=""></a>
                    </p>
                </div>
            `);
    clearInterval(interval); // Stop the interval once the element is found
  }
}, 100); // Check every 100ms



document.addEventListener('touchstart', function (e) {
  if (e.touches.length !== 1) return;

  const scrollY = window.scrollY;
  if (scrollY <= 0) {
    // Prevent pull-to-refresh by preventing default at the top
    window.scrollTo(0, 1); // push down a bit
    e.preventDefault();
  }
}, { passive: false });


// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelectorAll('.timer-wrap').forEach((wrap) => {
//     const timeStr = wrap.querySelector('.time_value')?.textContent?.trim();
//     if (!timeStr) return;

//     // Match DD/MM/YYYY HH:mm am/pm
//     const parts = timeStr.match(/(\d{2})\/(\d{2})\/(\d{4}) (\d{1,2}):(\d{2}) (am|pm)/i);
//     if (!parts) return;

//     let [_, day, month, year, hour, minute, ampm] = parts;
//     hour = parseInt(hour, 10);
//     minute = parseInt(minute, 10);

//     if (ampm.toLowerCase() === 'pm' && hour !== 12) hour += 12;
//     if (ampm.toLowerCase() === 'am' && hour === 12) hour = 0;

//     // Construct date in UK time (Europe/London)
//     const ukDate = new Date(Date.UTC(
//       parseInt(year, 10),
//       parseInt(month, 10) - 1,
//       parseInt(day, 10),
//       hour,
//       minute
//     ));

//     // Adjust for UK timezone offset at that date (handles DST automatically)
//     const ukFormatter = new Intl.DateTimeFormat("en-GB", {
//       timeZone: "Europe/London",
//       year: "numeric",
//       month: "2-digit",
//       day: "2-digit",
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: false
//     });

//     // Break formatted string into parts
//     const partsList = ukFormatter.formatToParts(ukDate);
//     const obj = Object.fromEntries(partsList.map(p => [p.type, p.value]));

//     const targetDate = new Date(
//       `${obj.year}-${obj.month}-${obj.day}T${obj.hour}:${obj.minute}:00+01:00`
//     );

//     function updateTimer() {
//       const now = new Date(); // user local time
//       const diff = targetDate - now;

//       const daysEl = wrap.querySelector('.days .time');
//       const hoursEl = wrap.querySelector('.hours .time');
//       const minutesEl = wrap.querySelector('.minutes .time');
//       const secondsEl = wrap.querySelector('.seconds .time');

//       if (diff <= 0) {
//         daysEl.textContent = "00";
//         hoursEl.textContent = "00";
//         minutesEl.textContent = "00";
//         secondsEl.textContent = "00";
//         clearInterval(timerInterval);
//         return;
//       }

//       const days = Math.floor(diff / (1000 * 60 * 60 * 24));
//       const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
//       const minutes = Math.floor((diff / (1000 * 60)) % 60);
//       const seconds = Math.floor((diff / 1000) % 60);

//       daysEl.textContent = String(days).padStart(2, '0');
//       hoursEl.textContent = String(hours).padStart(2, '0');
//       minutesEl.textContent = String(minutes).padStart(2, '0');
//       secondsEl.textContent = String(seconds).padStart(2, '0');
//     }

//     updateTimer();
//     const timerInterval = setInterval(updateTimer, 1000);
//   });
// });

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.timer-wrap').forEach((wrap) => {
    const timeStr = wrap.querySelector('.time_value')?.textContent?.trim();
    if (!timeStr) return;

    // Match DD/MM/YYYY HH:MMAM/PM format
    const parts = timeStr.match(/(\d{2})\/(\d{2})\/(\d{4}) (\d{1,2}):(\d{2})\s*(AM|PM)/i);
    if (!parts) return;

    let [_, day, month, year, hour, minute, ampm] = parts;
    hour = parseInt(hour, 10);
    minute = parseInt(minute, 10);

    // Convert to 24-hour format
    if (ampm.toUpperCase() === 'PM' && hour !== 12) hour += 12;
    if (ampm.toUpperCase() === 'AM' && hour === 12) hour = 0;

    // Create target date (assuming local timezone)
    const targetDate = new Date(
      parseInt(year, 10),
      parseInt(month, 10) - 1, // months are 0-indexed
      parseInt(day, 10),
      hour,
      minute,
      0
    );

    function updateTimer() {
      const now = new Date();
      const diff = targetDate - now;

      const daysEl = wrap.querySelector('.days .time');
      const hoursEl = wrap.querySelector('.hours .time');
      const minutesEl = wrap.querySelector('.minutes .time');
      const secondsEl = wrap.querySelector('.seconds .time');

      if (diff <= 0) {
        daysEl.textContent = "00";
        hoursEl.textContent = "00";
        minutesEl.textContent = "00";
        secondsEl.textContent = "00";
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      daysEl.textContent = String(days).padStart(2, '0');
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    updateTimer();
    const timerInterval = setInterval(updateTimer, 1000);
  });
});